<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Geocerca {{ form.descripcion }}</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            id="descripcion_geocerca"
            v-model="form.descripcion"
            placeholder="Escriba una descripción..."
          >
            Descripción*
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            vMoney
            :format="decimalCoordinates"
            id="radio"
            v-model="form.radio"
            placeholder="Escriba el radio..."
          >
            Radio (en metros)*
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            vMoney
            :format="decimalCoordinates"
            id="latitud"
            placeholder="Escriba una latitud..."
            v-model="form.latitud"
          >
            Latitud
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            vMoney
            :format="decimalCoordinates"
            id="longitud"
            placeholder="Escriba una longitud..."
            v-model="form.longitud"
          >
            Longitud
          </input-field>
        </div>
      </div>
    </div>
    <div class="modal-buttons">
      <button @click="aceptar" class="btn-success" type="button">
        <i class="fa fa-check"></i><span>Aceptar</span>
      </button>
      <button @click="cancelar" class="btn-danger btn--text" type="button">
        <i class="fa fa-times"></i><span>Cancelar</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
  },
  data: function () {
    return {
      form: this.value,
      decimalCoordinates: decimalCoordinates,
    };
  },
  methods: {
    aceptar: function () {
      if (this.form.descripcion.length == 0) {
        swal("Se requiere la descripción de la geocerca.", "Aviso", "warning");
        return;
      }
      let radio = parseFloat(this.form.radio);
      if (isNaN(radio)) {
        radio = 0;
      }
      if (radio == 0) {
        swal(
          "El radio es requerido y debe ser mayor a cero.",
          "Aviso",
          "warning"
        );
        return;
      }
      let latitud = parseFloat(this.form.latitud);
      let longitud = parseFloat(this.form.longitud);
      if (isNaN(latitud)) {
        swal("La latitud es requerida.", "Aviso", "warning");
        return;
      }
      if (isNaN(longitud)) {
        swal("La longitud es requerida.", "Aviso", "warning");
        return;
      }
      this.form.latLng = [
        parseFloat(this.form.latitud),
        parseFloat(this.form.longitud),
      ];
      this.$emit("aceptar", this.form);
    },
    cancelar: function () {
      this.$emit("cancelar");
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/rutas/Geocerca.vue